import {Modal} from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import React, {useEffect, useState} from 'react';
import {LOCAL_STORAGE_USER_LOGIN_INFO, ResponseCode} from "@app/constants/Common";
import MailBodyEditorContent from "@pages/email/common/view/MailBodyEditorContent";
import {alertMessage} from "@app/constants/Messages";
import {requestSaveInviteJobMailTemp} from "@app/services/InviteJobMailTemplateService";
import {MailTempType} from "@pages/email/common/Constant";
import {cloneDeep} from "lodash";

const InitContent = {
    name: "",
    note: "",
    signature_body: "",
    job_table_body: "",
    body_content: "",
}

const UpdateSimpleMailTemplateModal = (props) => {
    const [mailTemp, setMailTemp] = useState(InitContent);
    const [mailContent, setMailContent] = useState("");
    const [isAddMode, setAddMode] = useState(true)
    const [isLoading, setIsLoading] = useState(false)
    const [userLoginInfo, setUserLoginInfo] = useState({});

    const {template, isShow, onClose} = props

    useEffect(() => {
        let loginUser = {}
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            loginUser = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO))
            setUserLoginInfo(loginUser)
        }
    }, [])

    useEffect(() => {
        if (template) {
            setMailTemp(cloneDeep(template))
            setAddMode(!template.id)
        }
    }, [template]);

    const onCloseModal = (reload) => {
        setMailTemp(InitContent)
        onClose(reload)
    }

    const onUpdateRequest = () => {
        if (mailTemp.template_type === MailTempType.SIGNATURE) {
            mailTemp.signature_body = mailContent
        } else if (mailTemp.template_type === MailTempType.JOB_TABLE) {
            mailTemp.job_table_body = mailContent
        }

        requestSaveInviteJobMailTemp(mailTemp).then((res) => {
            if (res.sts_code === ResponseCode.SUCCESS) {
                onCloseModal(res.sts_code === ResponseCode.SUCCESS)
            } else {
                alertMessage(res.sts_code)
            }
        }).catch((error) => {
            console.log(`Error:${JSON.stringify(error)}`);
        }).finally(() => {
            setIsLoading(false);
        });
    }

    const onChangeInputItem = (values, field) => {
        mailTemp[field] = values
        setMailTemp(cloneDeep(mailTemp))
    }

    const onChangeMailContent = (contents) => {
        setMailContent(contents)
    }

    const getScreenTitle = () => {
        if (mailTemp.template_type === MailTempType.SIGNATURE) {
            return "Thông tin template chữ ký"
        }

        if (mailTemp.template_type  === MailTempType.JOB_TABLE) {
            return "Thông tin template Job table"
        }

        return "Thông tin template"
    }

    const getMailContent = () => {
        if (mailTemp.template_type === MailTempType.SIGNATURE) {
            return mailTemp.signature_body
        }
        return mailTemp.job_table_body
    }

    return (
        <>
            <Modal show={isShow}
                   size={'xl'}
                   onHide={() => onCloseModal()}
                   animation={false}>
                <Modal.Header>
                    <Modal.Title>{getScreenTitle()}</Modal.Title>
                    <Button variant='secondary' onClick={() => onCloseModal()}>
                        Close
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <div className={"row"}>
                        <div className='col-sm-12'>
                            <div className="form-group">
                                <label>Tên template</label>
                                <input className="form-control" value={mailTemp.name}
                                       name={"name"}
                                       onChange={(event) => onChangeInputItem(event.target.value, "name")}
                                       type={"text"}/>
                            </div>
                            <div className="form-group">
                                <label>Note</label>
                                <input className="form-control" value={mailTemp.note}
                                       name={"note"}
                                       onChange={(event) => onChangeInputItem(event.target.value, "note")}
                                       type={"text"}/>
                            </div>
                            <div className="form-group">
                                <label>Nội dung</label>
                                <MailBodyEditorContent
                                    onChange={(values) => onChangeMailContent(values, 'body_content')}
                                    content={getMailContent()}/>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button type='button'
                            className='btn btn-primary'
                            isLoading={isLoading}
                            disabled={isLoading}
                            onClick={() => {
                                onUpdateRequest()
                            }}
                            >
                        <i className='fas fa-save mr-2'/>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default UpdateSimpleMailTemplateModal;
